import {area} from '../path/shapes';
import {pickArea} from '../util/pickPath';
import markMultiItemPath from './markMultiItemPath';

export default markMultiItemPath('area', area, pickArea);



// WEBPACK FOOTER //
// ./~/vega-scenegraph/src/marks/area.js